import ReactGA from 'react-ga4';
const tracking = (category, action, label) => {
  ReactGA.initialize('G-CTJPHRS075');
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
};

export default tracking;